import React, { forwardRef } from 'react'

import { IconProps } from './types'

const User = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8.5C5.5 8.5 3.5 10.5 3.5 13H12.5C12.5 10.5 10.5 8.5 8 8.5Z"
        stroke={color}
      />
      <path
        d="M10 4.5C10 5.60457 9.10457 6.5 8 6.5C6.89543 6.5 6 5.60457 6 4.5C6 3.39543 6.89543 2.5 8 2.5C9.10457 2.5 10 3.39543 10 4.5Z"
        stroke={color}
      />
    </svg>
  ),
)

User.displayName = 'User'

User.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default User
